import { render, staticRenderFns } from "./UserSetup.vue?vue&type=template&id=c1e7545a&scoped=true&"
import script from "./UserSetup.vue?vue&type=script&lang=js&"
export * from "./UserSetup.vue?vue&type=script&lang=js&"
import style0 from "./UserSetup.vue?vue&type=style&index=0&id=c1e7545a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e7545a",
  null
  
)

export default component.exports